/**
 * "I GOT GOD. I CAN'T LOSE." hoodie + sweatpants landing page.
 * Only used by sections/i-got-god-landing.liquid (templates/page.i-got-god.json).
 *
 * Adds the two currently-selected REAL Shopify variants (hoodie + pants)
 * as two separate line items via Shopify's native multi-item Ajax Cart
 * API - same product, same SKU, same inventory, same fulfillment as
 * adding them individually from their own product pages. No bundle SKU,
 * no combined product. /cart/add.js's multi-item form is atomic: if
 * either variant fails to add, nothing is added and an error is
 * returned, so a customer is never left with only one of the two items
 * silently added.
 */
(function () {
  function getSelected(root, key) {
    var checked = root.querySelector('[data-igg-sizes="' + key + '"] input:checked');
    return checked ? checked.dataset.variantId : null;
  }

  function showMessage(el, text, isError) {
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    el.classList.toggle('igg-shop__message--error', !!isError);
  }

  function addToCart(items, button, messageEl) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    if (messageEl) messageEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            var message = data.description || data.message || 'Something went wrong. Please try again.';
            throw new Error(message);
          });
        }
        return res.json();
      })
      .then(function () {
        button.disabled = false;
        button.textContent = originalText;
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        if (window.theme && window.theme.settings && window.theme.settings.afterAddToCart === 'drawer') {
          var drawer = document.querySelector('.js-cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open(button);
        }
      })
      .catch(function (err) {
        button.disabled = false;
        button.textContent = originalText;
        showMessage(messageEl, err.message || 'Something went wrong. Please try again.', true);
      });
  }

  function init(root) {
    var setCta = root.querySelector('[data-igg-set-cta]');
    var setMessage = root.querySelector('[data-igg-message]');

    if (setCta) {
      setCta.addEventListener('click', function () {
        var hoodieId = getSelected(root, 'hoodie');
        var pantsId = getSelected(root, 'pants');

        if (!hoodieId || !pantsId) {
          showMessage(setMessage, 'Please select a size for both the hoodie and the sweatpants.', true);
          return;
        }

        addToCart(
          [
            { id: hoodieId, quantity: 1 },
            { id: pantsId, quantity: 1 }
          ],
          setCta,
          setMessage
        );
      });
    }

    root.querySelectorAll('[data-igg-individual]').forEach(function (btn) {
      var key = btn.dataset.iggIndividual;
      btn.addEventListener('click', function () {
        var variantId = getSelected(root, key);
        if (!variantId) return;
        addToCart([{ id: variantId, quantity: 1 }], btn, null);
      });
    });

    var scrollCta = root.querySelector('[data-igg-scroll-to]');
    if (scrollCta) {
      scrollCta.addEventListener('click', function (evt) {
        var target = root.querySelector(scrollCta.dataset.iggScrollTo);
        if (!target) return;
        evt.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function ready() {
    document.querySelectorAll('[data-igg-landing]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
